import { useTranslation } from 'react-i18next'
import { MenuItem, Select, SelectChangeEvent } from '@mui/material'

import { VISIBILITY_VALUES } from '../constants'
import { VisibilityInCenter } from '../types'
import { useSetVisibilityInCenter } from '../use-site-actions'

type VisibilitySelectProps = {
  siteId: string
  value: VisibilityInCenter | null
}

const isVisibilityInCenter = (visibility: string): visibility is VisibilityInCenter =>
  VISIBILITY_VALUES.includes(visibility as VisibilityInCenter)

const VisibilitySelect = ({ siteId, value }: VisibilitySelectProps) => {
  const { t } = useTranslation()
  const { setVisibility, loading } = useSetVisibilityInCenter(siteId)

  const handleChange = (event: SelectChangeEvent<VisibilityInCenter | ''>) => {
    const nextVisibility = event.target.value
    if (!isVisibilityInCenter(nextVisibility) || nextVisibility === value) return
    setVisibility(nextVisibility)
  }

  return (
    <Select<VisibilityInCenter | ''>
      value={value ?? ''}
      onChange={handleChange}
      disabled={loading}
      size="small"
      inputProps={{ 'aria-label': t('admin_sites.table.visibility_in_center') }}
      sx={{
        height: 28,
        minWidth: 120,
        borderRadius: '8px',
        fontSize: 12,
        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#EFEFEF' },
        '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#D7DAEA' },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2570EB' }
      }}
    >
      {VISIBILITY_VALUES.map(visibility => (
        <MenuItem key={visibility} value={visibility} sx={{ fontSize: 12 }}>
          {t(`admin_sites.visibility.${visibility}`)}
        </MenuItem>
      ))}
    </Select>
  )
}

export default VisibilitySelect
